import { render, staticRenderFns } from "./OrganismRequestOfferModal.vue?vue&type=template&id=4601ab34&"
import script from "./OrganismRequestOfferModal.vue?vue&type=script&lang=js&"
export * from "./OrganismRequestOfferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectMoleculeRequestOffer: require('/app/components/molecules/project/MoleculeRequestOffer.vue').default,MoleculesProjectMoleculeSendRequest: require('/app/components/molecules/project/MoleculeSendRequest.vue').default})
